<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SOzljy/tc-custom/9780802192851.jpg?1726871176525" alt="This image is the cover for the book Antiquarian"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Antiquarian
      </h1>
      <p class="bookDescription body article font2">
        <b>“Riddle by riddle, a murder confession unspools” in this “delightfully macabre” literary thriller of madness, mystery, and antique books (<i>The New York Times</i>). </b><br/><br/>Three years have passed since Gustavo, a renowned psycholinguist, last spoke to his closest friend, Daniel, who has been interned in a psychiatric ward after brutally murdering his fiancée and attempting suicide. When Daniel unexpectedly calls to confess the truth behind the crime, Gustavo’s long buried fraternal loyalty draws him into the center of a quixotic, mystifying investigation through an underground network of antiquarian dealers.<br/><br/>While Daniel reveals his unsettling story using fragments of fables, novels, and historical allusions, Gustavo begins to retrace the past for clues: from their early college days exploring dust-filled libraries and exotic brothels to Daniel’s intimate attachment to his sickly younger sister and his dealings as a book collector. Soon, Gustavo must deduce a complex series of events from allegories that are more real than police reports and metaphors more revealing than evidence. And when a woman in the ward is found murdered, Daniel is declared the prime suspect, and Gustavo plummets deeper into the mysterious case.<br/><br/><b>“An ambitious, complex novel…those who read by simultaneously working with the writer, fantasizing alongside him, capable of enjoying the subtleties and secrets of a text as rich and profound as the text of this novel, will never forget it.” —Mario Vargas Llosa</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gustavo Faverón Patriau, Joseph Mulligan
      </h2>
      
      <p class="authorDescription body article">Gustavo Faverón Patriau is the director of the Latin American Studies Program and an associate professor of Romance languages at Bowdoin College. He is the author of two books of literary theory and has edited anthologies on Roberto Bolaño and Peruvian literature. As a journalist and a literary and social critic, his articles and essays have appeared around the world in such publications as Daily Kos, Etiqueta Negra, and Cuadernos Hispanoamericanos.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Black Cat
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bf20a5b8